export interface WalletBalance {
  timestamp: string;
  status: string;
  data: WalletBalanceData;
}

export interface WalletBalanceData {
  balances: Balance[];
  totalBalance: number;
  totalFutureBalance: number;
  totalCombinedBalance: number;
  defaultCurrency: string;
}

export interface Balance {
  availableBalance: number;
  futureBalance: number;
  currencyType: string;
  exchangeRate: ExchangeRate;
  settlementInfo: SettlementInfo | null;
}

export interface ExchangeRate {
  rate: number;
  userDefaultCurrencyType: string;
}

export interface SettlementInfo {
  futureBalance: {
    totalPending: number;
    associatedSales: AssociatedSale[];
  };
}

export interface AssociatedSale {
  saleName: string;
  saleId: string;
  hash: string;
  releaseSchedule: ReleaseSchedule[];
}

export interface ReleaseSchedule {
  date: string;
  amount: number;
  description: string;
  currencyType: string;
}

export function createEmptyWalletBalanceData(): WalletBalanceData {
  return {
    balances: [],
    totalBalance: 0,
    totalFutureBalance: 0,
    totalCombinedBalance: 0,
    defaultCurrency: '',
  };
}
